import React from 'react'
import _ from 'lodash'
import {
  openDialog,
  openErrorDialog,
  openSuccessDialog,
} from 'src/redux/slices/alertDialog'
import Consent from './Consent'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const getError = (formError, obj) => {
  const error = _.find(formError, (ele) => {
    return ele.path == obj
  })
  return error?.message || ''
}

export const handleDownload = async (title, url, type) => {
  if (type === 'pdf') {
    fetch(url, {
      method: 'get',
      credentials: 'include',
      xhrFields: {
        responseType: 'blob',
      },
    })
      .then((res) => res.blob())
      .then((data) => {
        var a = document.createElement('a')
        var url = window.URL.createObjectURL(data)
        a.href = url
        a.download = `${title}`
        document.body.append(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      })
  } else {
    const a = document.createElement('a')
    a.href = await toDataURL(url)
    a.download = `${title}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export const toDataURL = async (url) => {
  const blob = await fetch(url, { credentials: 'include' }).then((res) =>
    res.blob(),
  )
  return URL.createObjectURL(blob)
}

export const handleConsent = () => (dispatch) => {
  dispatch(
    openDialog({ type: 'custom', customWidth: '85%', content: <Consent /> }),
  )
}

export const handleError = (error) => (dispatch) => {
  if (!error) return
  const title = _.get(error, 'constraints.title', 'ไม่สำเร็จ')
  const message = _.get(error, 'constraints.value', 'ดำเนินการไม่สำเร็จ')
  dispatch(
    openErrorDialog({
      title,
      message: message.split(' '),
      buttonRight: {
        handleClick: () => (window.location.href = '/my-class'),
      },
    }),
  )
}

export const handleSuccess = (res, isResend) => (dispatch) => {
  const courseUuid = _.get(res, 'content.courseUuid', '')
  const trainingPlanUuid = isResend
    ? _.get(res, 'uuid', '')
    : _.get(res, 'content.trainingPlanUuid', '')
  const href = isResend
    ? `/my-class/registration-detail/${trainingPlanUuid}`
    : `/course/${courseUuid}/class/${trainingPlanUuid}`
  dispatch(
    openSuccessDialog({
      title: 'ส่งเอกสารสำเร็จ',
      message: ['รอเจ้าหน้าที่ตรวจสอบเอกสาร'],
      handleClick: () => (window.location.href = href),
    }),
  )
}
